"use strict";

import { addEvent } from "../addEvent/addEvent";

export function mousePosition() {
  const hoverBox = document.body; //document.querySelector("#page-smooth-scroll");

  let div = document.createElement("div");
  div.classList.add("mouse-dot");
  document.body.appendChild(div);

  hoverBox.addEventListener("mousemove", (event) => {
    event.stopPropagation();
    const target = event.target;

    const x = event.pageX; // - hoverBox.offsetWidth / 2;
    const y = event.pageY; // - hoverBox.offsetHeight / 2;

    document.body.style.setProperty("--x", `${x}px`);
    document.body.style.setProperty("--y", `${y}px`);
  });
}

export function mousePositionElement(elements) {
  if (!elements) {
    const hoverBox = document.getElementsByClassName("mouse-hover"); //document.querySelector("#page-smooth-scroll");
    const hoverLinks = document.getElementsByTagName("a"); //document.querySelector("#page-smooth-scroll");
    const hoverButtons = document.getElementsByTagName("button"); //document.querySelector("#page-smooth-scroll");

    elements = [...hoverBox, ...hoverLinks, ...hoverButtons];
  }

  Array.from([...elements]).forEach((elm) => {
    let video = elm.getElementsByTagName("video");
    let dotClass = elm.getAttribute("data-dotclass");

    if (!dotClass) dotClass = "over-element";

    elm.addEventListener("mouseover", (event) => {
      event.stopPropagation();
      document.body.classList.add(dotClass);

      if (video.length > 0) {
        video[0].loop = true;
        video[0].play();
      }
    });

    elm.addEventListener("mouseout", (event) => {
      event.stopPropagation();
      document.body.classList.remove(dotClass);

      if (video.length > 0) {
        video[0].loop = false;
        if (video[0].dataset.pauseout || false) video[0].pause();
      }
    });

    elm.addEventListener("mousemove", (event) => {
      //event.stopPropagation();
      const x = event.offsetX; // - elm.offsetWidth / 2;
      const y = event.offsetY; // - elm.offsetHeight / 2;

      elm.style.setProperty("--elementX", `${x}px`);
      elm.style.setProperty("--elementY", `${y}px`);

      const trX = event.offsetX - elm.offsetWidth / 2;
      const trY = event.offsetY - elm.offsetHeight / 2;

      const percentageX = (trX / (elm.offsetWidth / 2)) * -100;
      const percentageY = (trY / (elm.offsetHeight / 2)) * -100;

      elm.style.setProperty("--elementTranslateProcentX", `${percentageX}%`);
      elm.style.setProperty("--elementTranslateProcentY", `${percentageY}px`);

      //document.body.classList.add("hide-dot");
    });
  });
}
